















































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { Toast } from 'vant'

const retreatCouponModule = namespace('retreatCoupon')

@Component({
  components: {}
})
export default class FaceCouponsSure extends Vue {
  @retreatCouponModule.State('couponInfo') couponInfo!: any
  defaultImg: any = require('@/image/default.png')
  mounted() {
    console.log(this.couponInfo)
    this.setActive()
    this.getInfo()
  }
  setActive() {
    this.$store.commit('retreatCoupon/setSelectStep', 2)
  }
  async getInfo() {
    const { success } = await this.$store.dispatch(
      'retreatCoupon/couponCodeInfo',
      {
        couponInstanceQrCode: this.$route.query.couponInstanceQrCode
      }
    )
  }
  async sureCoupon() {
    let param = {
      couponInstanceQrCode: this.couponInfo.couponInstanceQrCode,
      writeOffBusinessEntityId: this.$global.tenantId,
      writeOffChannel: '商户通',
      userId: this.$global.uId,
      userName: this.$global.uName,
      flowType: 1
    }
    console.log(param)
    const { error, success } = await this.$store.dispatch(
      'retreatCoupon/couponRetreat',
      param
    )
    if (success) {
      Toast('退券成功')
      sessionStorage.setItem(
        'retreatCouponMsg',
        JSON.stringify(this.couponInfo)
      )
      setTimeout(() => {
        this.$router.push(`/retreatCoupon/success`)
      }, 100)
    } else {
      Toast(error.msg)
    }
  }
}
